export default __webpack_public_path__ + "static/media/Profile-Shot.42f48396.jpg";